@defer (on viewport; ) {
    @if(parentFilterLoaded){
        @if (widgetData$ | async; as data) {
            <bizz-form-collection-list #formCollectionList
                    [data]="data"
                    (onWidgetDataLoaded)="dataFetched($event)"
                    [ngClass]="{'report-control': reportControl}"
                    [parentFilter]="parentFilter"
                    [openLinksInStack]="openLinksInStack"
                    [readOnly]="readOnly()"
                    [userReversedFixedGroupsFilter]="userReversedFixedGroupsFilter"
                    [tabIndex]="readOnly() ? -1  : 0" [reportControl]="reportControl">
            </bizz-form-collection-list>
        }
    }
} @placeholder {
    <bizz-loader class="h-24 w-full bg-form/30"></bizz-loader>
}
